import type { ThemeConfig } from "antd";
import { BRAND } from "./brand";

export const sushi2goTheme: ThemeConfig = {
  token: {
    colorPrimary: BRAND.primary,
    colorLink: BRAND.primary,
    colorLinkHover: BRAND.primaryHover,
    colorInfo: BRAND.primary,
    colorSuccess: "#22c55e",
    colorWarning: "#f59e0b",
    colorError: "#ef4444",
    colorBgLayout: "#f4f6f9",
    colorBgContainer: "#ffffff",
    colorBorder: "#e8edf2",
    colorText: "#1e293b",
    colorTextSecondary: "#64748b",
    borderRadius: 10,
    borderRadiusLG: 14,
    fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
    fontSize: 14,
    controlHeight: 40,
    boxShadow: "0 1px 3px rgba(15, 23, 42, 0.06)",
    boxShadowSecondary: "0 4px 16px rgba(15, 23, 42, 0.08)",
  },
  components: {
    Layout: {
      headerBg: "#ffffff",
      siderBg: "#ffffff",
      bodyBg: "#f4f6f9",
    },
    Menu: {
      itemBorderRadius: 10,
      itemHeight: 44,
      itemMarginInline: 8,
      itemMarginBlock: 4,
      iconSize: 18,
      itemSelectedColor: BRAND.primary,
      itemSelectedBg: BRAND.primaryLight,
      itemHoverBg: "#f8fafc",
      itemHoverColor: BRAND.primary,
      subMenuItemBg: "transparent",
    },
    Button: {
      primaryShadow: BRAND.primaryShadow,
      fontWeight: 600,
      borderRadius: 10,
      colorPrimary: BRAND.primary,
      colorPrimaryHover: BRAND.primaryHover,
      colorPrimaryActive: "#c44128",
    },
    Radio: {
      buttonSolidCheckedBg: BRAND.primary,
      buttonSolidCheckedHoverBg: BRAND.primaryHover,
      buttonSolidCheckedActiveBg: "#c44128",
      colorPrimary: BRAND.primary,
    },
    Switch: {
      colorPrimary: BRAND.primary,
      colorPrimaryHover: BRAND.primaryHover,
    },
    Checkbox: {
      colorPrimary: BRAND.primary,
      colorPrimaryHover: BRAND.primaryHover,
    },
    Tabs: {
      itemSelectedColor: BRAND.primary,
      itemHoverColor: BRAND.primaryHover,
      inkBarColor: BRAND.primary,
    },
    Table: {
      headerBg: "#f8fafc",
      headerColor: "#475569",
      rowHoverBg: "#fff8f5",
      borderColor: "#e8edf2",
      borderRadius: 12,
    },
    Card: {
      borderRadiusLG: 14,
      paddingLG: 20,
    },
    Modal: {
      borderRadiusLG: 16,
      titleFontSize: 18,
      titleColor: BRAND.primary,
    },
    Drawer: {
      borderRadiusLG: 0,
    },
    Input: {
      borderRadius: 10,
      activeBorderColor: BRAND.primary,
      hoverBorderColor: "#f4a88a",
    },
    Select: {
      borderRadius: 10,
    },
    Pagination: {
      itemActiveBg: BRAND.primary,
      borderRadius: 8,
    },
    Tag: {
      borderRadiusSM: 6,
    },
    Slider: {
      colorPrimary: BRAND.primary,
      colorPrimaryBorder: BRAND.primary,
    },
    Progress: {
      defaultColor: BRAND.primary,
    },
  },
};
